module.exports = __webpack_public_path__ + "img/Group19@2x.b165c80c.png";